import React, { useEffect, useState } from 'react';
import logo from './logo.svg';
import './App.css';
import Typography from '@mui/material/Typography';
import { AppBar, Box, Button, Container, Divider, IconButton, Link, Toolbar } from '@mui/material';
import LogoMedium from './images/huji_banner.png';
import LogoSmall from './images/heb-uni-logo-768.png';
import CSBanner from './images/cse_banner.png';
import Logo from './images/logo.png';
import Calculator from './components/Calculator';
import { Faculty, Lang } from './types/general';
import { AppStringsByLang } from './terms/appTerms';
import createCache from '@emotion/cache';
import { prefixer } from 'stylis';
import rtlPlugin from 'stylis-plugin-rtl';
import { CacheProvider } from '@emotion/react';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import { createTheme as materialCreateTheme, THEME_ID, ThemeProvider as MaterialThemeProvider, } from '@mui/material/styles';
import { getFaculty } from './utils/appUtils';
import { useTheme } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';

// Create rtl cache
const cacheRtl = createCache({
  key: 'muirtl',
  stylisPlugins: [prefixer, rtlPlugin],
});

function RTL(props: any) {
  return <CacheProvider value={cacheRtl}>{props.children}</CacheProvider>;
}
const materialTheme = materialCreateTheme({
  palette: {
    primary: { main: "rgb(0,147,149)" },
    secondary: { main: "#763160" }
  }
});

function App() {
  const [lang, setLang] = useState<Lang>(localStorage.getItem("calculatorLang") as Lang || Lang.he);
  const Strings = AppStringsByLang(lang);
  const faculty = getFaculty();
  const theme = useTheme();
  const isDownMD = useMediaQuery(theme.breakpoints.down('md'));

  useEffect(() => {
    document.dir = lang === Lang.he ? 'rtl' : 'ltr';
  }, [lang]);

  const WrapperComponent = lang === Lang.he ? RTL : Box;

  const changeLang = (newLang: Lang) => {
    localStorage.setItem("calculatorLang", newLang);
    setLang(newLang);
  };

  return (
    <WrapperComponent >
      <MaterialThemeProvider theme={{ [THEME_ID]: materialTheme }}>
        <LocalizationProvider dateAdapter={AdapterMoment}>
          <Box sx={{ flexGrow: 1 }}>
            <AppBar position="static" variant='outlined' sx={{ backgroundColor: "#f8f8f8", border: "none" }}>
              <Toolbar sx={{ display: "flex", justifyContent: "space-between", py: "16px" }}>
                <Box sx={{ display: "flex" }}>
                  <Link href="https://new.huji.ac.il" aria-label="Heb Uni"
                    target="_blank" rel="noopener">
                    <img src={faculty === Faculty.CSE && isDownMD ? Logo : LogoMedium} style={{ maxWidth: "100%", height: "auto" }} />
                  </Link>
                </Box>
                {faculty === Faculty.CSE && <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center", }}>
                  <Link href="https://cs.huji.ac.il/" aria-label="CS Banner"
                    target="_blank" rel="noopener" >
                    <img src={CSBanner} style={{ maxWidth: "100%", height: "auto" }} />
                  </Link>
                  {/* <Button onClick={() => changeLang(Lang.en)}>EN</Button>
                  <Divider orientation="vertical" sx={{ height: "1.5rem", mx: "2px" }} />
                  <Button onClick={() => changeLang(Lang.he)}>He</Button> */}
                </Box>}
              </Toolbar>
            </AppBar>
          </Box>
          <Container maxWidth="sm">
            <Box sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid lightblue",
              mt: "24px",
              borderRadius: "8px",
              py: "16px",
              px: "16px",
              mb: "32px"
            }}>

              <Typography variant="h4" mt="16px" mb="8px" component="div" align='center' fontWeight="bold" sx={{ flexGrow: 1 }}>
                {Strings.appTitle}
              </Typography>
              <Typography variant="body1" mb="24px" component="div" align='center' sx={{ flexGrow: 1 }}>
                {Strings.appSubTitle}
                <Link href="https://new.huji.ac.il/news/%D7%94%D7%A7%D7%9C%D7%95%D7%AA-%D7%95%D7%94%D7%AA%D7%90%D7%9E%D7%95%D7%AA-%D7%90%D7%A7%D7%93%D7%9E%D7%99%D7%95%D7%AA"
                  target="_blank" rel="noopener">
                  {Strings.here}
                </Link>
                {Strings.appSubTitle2}
              </Typography>
              <Calculator lang={lang} />
            </Box>
          </Container>
        </LocalizationProvider>
      </MaterialThemeProvider>
    </WrapperComponent>
  );
}

export default App;
